import React, { useState } from 'react';
import {
  Grid,
  Card,
  Typography,
  Slide
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { DropzoneArea } from 'material-ui-dropzone';
import Interweave from 'interweave';


export default ({onUploadComplete}) => {
  const classes = useStyles();
  const { t } = useTranslation(['label', 'button', 'form', 'files']);
  const [attach, setAttach] = useState(null);  

  const history = useHistory();

  const handleChangeFileList = (files) => {
    onUploadComplete(files)
    setAttach(files);
};


return (
    <div className={classes.root}>
      <Grid container spacing={4}>
          <Card className={classes.card}>
            <Grid
              direction="column"
              justify="space-between"
              alignItems="center"
            >
                <Slide direction="left" in={true} mountOnEnter unmountOnExit>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography>
                                <Interweave content={t('form:Team.Configuration.text5_massive')} />
                            </Typography>
                        </Grid>
                        <DropzoneArea
                            filesLimit={1}
                            maxFileSize={52428800}
                            onChange={(files) => handleChangeFileList(files)}
                            dropzoneText={'Arraste e Solte (para adicionar a planilha com os dados)'}
                            acceptedFiles={[
                                '.csv',
                                '.xlsx',
                                '.xls',
                                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 
                                'application/vnd.ms-excel', 
                                'text/csv',
                              ]}
                        />
                    </Grid>
                </Slide>
            </Grid>
          </Card>
      </Grid>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
    root: {
      padding: theme.spacing(1),
    },
    button: {
      textTransform: 'capitalize',
      width: '100%',
      marginTop: theme.spacing(2),
    },
    card: {
      padding: theme.spacing(4),
      marginTop: theme.spacing(1),
    },
    instructions: {
      listStyle: 'none',
      paddingLeft: 0,
      marginTop: theme.spacing(2),
      '& li': {
        marginBottom: theme.spacing(1),
        fontSize: '1rem',
      },
    },
    link: {
      color: theme.palette.primary.main,
      textDecoration: 'none',
      fontWeight: 500,
    },
    divider: {
      margin: `${theme.spacing(3)}px 0`,
      border: 'none',
      borderTop: `1px solid ${theme.palette.divider}`,
    },
}));

